import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { slugs } from "../../../Constant/slugs";
import { AdsGETApiAuth } from "../../../Constant/api";
import { CSVLink } from "react-csv";

const columns = [
  {
    id: 1,
    name: "id",
    selector: (row) => row.id,
    sortable: true,
    reorder: true,
  },
  {
    id: 2,
    name: "Name",
    selector: (row) => row.meta.name,
    sortable: true,
    reorder: true
  },
  {
    id: 3,
    name: "Phone",
    selector: (row) => row.meta.phone_number,
    sortable: true,
    reorder: true
  },

  {
    id: 4,
    name: "email",
    selector: (row) => row.meta.email_address,
    sortable: true,
    reorder: true
  },
  {
    id: 5,
    name: "Message",
    selector: (row) => row.meta.message,
    sortable: true,
    reorder: true
  },
  {
    id: 6,
    name: "Date",
    selector: (row) => row.date.slice(0, 10),
    sortable: true,
    reorder: true
  },
  {
    id: 7,
    name: "View",
    right: true,
    cell: (row) => <Link to={`${slugs.batch_details}${row.slug}`}>View</Link>,

  }
];

export default function AllGeneralForm() {
  const [Projects1, setProjects1] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const [CustomersDownload, setCustomersDownload] = React.useState([])
  const [DateAttendence, setDateAttendence] = React.useState("")

  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(params, "small_form")
      .then((res) => {
        setProjects1(res.data)
        setCustomersList(res.data)
        sortForDownload(res.data)
        console.log("done")
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  useEffect(() => {
    GetAllProjects({
      per_page: 100,
      _fields: "id,title,slug,meta,date"
    })

  }, [])
  var date = new Date()
  var today = date.toLocaleDateString()
  const isoToDmy = (iso) => {
    if (!iso) return "";
    console.log(iso)
    const [y, m, d] = iso.split("-");
    return `${y}-${m}-${d}`; // DD/MM/YYYY
  };
  const isoToDmyNumber = (iso) => {
    if (!iso) return "";
    console.log(iso)
    const [y, m, d] = iso.split("-");
    return `${Number(m)}/${d}/${y}`; // DD/MM/YYYY
  };

  const dmyToIso = (dmy) => {
    if (!dmy) return "";
    const [d, m, y] = dmy.split("/");
    const dd = String(d).padStart(2, "0");
    const mm = String(m).padStart(2, "0");
    return `${y}-${mm}-${dd}`; // YYYY-MM-DD
  };
  // const inputValueISO = useMemo(() => dmyToIso(dateDMY), [dateDMY]);

  const handleChange = (e) => {
    const iso = e.target.value       // "YYYY-MM-DD"
    const dmy = isoToDmy(iso);           // "DD/MM/YYYY"
    const dmy2 = isoToDmyNumber(iso);
    console.log("await", dmy, dmy2)
    setDateAttendence(iso)
    console.log(CustomersList, dmy, dmy2, iso)
    var newdata = CustomersList.filter(a => a.date.includes(dmy) || a.date.includes(dmy2))
    setProjects1(newdata)
    sortForDownload(newdata)
    // setDateDMY(dmy);                     // ✅ set on change
  };

  const sortForDownload = (DataArray) => {
    var dData = []
    for (let i = 0; i < DataArray.length; i++) {
      var item = DataArray[i]
      dData.push({
        id: item.id,
        name: item.meta.name,
        phone_number: item.meta.phone_number,
        email: item.meta.email_address,
        date: item.date.slice(0,10),
        message:item.meta.message
      })
    }
    setCustomersDownload(dData)
    console.log("done", dData)
  }
  const headers = [
    { label: "Name", key: "name" },
    { label: "Phone Number", key: "phone_number" },
    { label: "Email Address", key: "email_address" },
    { label: "Message", key: "message" },
    { label: "Date", key: "date" },
  ];

  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>General Form</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Batches
        </div>
      </div>
      <div style={{ display: "inline-block" }}>
        <input
          type="date"
          onChange={handleChange}
        />
      </div>

      <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}>
        <CSVLink data={CustomersDownload} headers={headers} className="Link"
          filename={`StudentData-${date.toLocaleString()}.csv`}
        >

          Download Excel
        </CSVLink>
      </div>
      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <DataTable
          columns={columns}
          data={Projects1}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          pagination
          selectableRows
        />
      </div>
      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div>
  )
}